import {
    StandardAdvancedSettings,
    AdvancedSettingsPanel,
    MaxLength,
    FieldMask,
} from 'apps/studio/components/settings/fields/Base/advanced'
import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

export const AdvancedPanel = AdvancedSettingsPanel([
    SettingsLabel('Config'),
    MaxLength,
    FieldMask,
    ...StandardAdvancedSettings
])
